// NHL team colours tuned for the dark UI: real primary unless it's too dark to read,
// then the team's own secondary/brand accent (never a washed-out grey).
const ALT = {
    ANA: "#B9975B", BOS: "#FFFFFF", BUF: "#FCB514", CGY: "#F1BE48", CAR: "#A2AAAD", CHI: "#FFD100",
    COL: "#236192", CBJ: "#CE1126", DAL: "#A2AAAD", DET: "#FFFFFF", FLA: "#B9975B",
    LAK: "#FFFFFF", MIN: "#DDCBA4", MTL: "#3B5BDB", NSH: "#FFFFFF", NJD: "#FFFFFF", NYI: "#F47D30",
    NYR: "#CE1126", OTT: "#C2912C", PHI: "#FFFFFF", PIT: "#FFFFFF", SJS: "#EA7200", SEA: "#E9072B",
    STL: "#FCB514", TBL: "#3B82F6", TOR: "#3B82F6", UTA: "#FFFFFF", VAN: "#00843D", VGK: "#C8102E",
    WSH: "#4F7FD1", WPG: "#AC162C",
};
const rgb = (h) => { const x = String(h || "#8A94A6").replace("#", ""); return [0, 2, 4].map((i) => parseInt(x.slice(i, i + 2), 16) || 0); };
const lum = (a) => (0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2]) / 255;
const dist = (a, b) => Math.hypot(...rgb(a).map((v, i) => v - rgb(b)[i]));

export const teamDisplayColor = (abbr, primary) => primary || "#8A94A6";

// Each team's own official primary colour — nothing swapped or lightened.
export const pairColors = (away, home, colorBy = {}) => ({ [away]: teamDisplayColor(away, colorBy[away]), [home]: teamDisplayColor(home, colorBy[home]) });

// Both teams share a colour (WSH/CAR reds) → the away side shows its own secondary.
// Edmonton has no alt — it stays orange; the other side changes instead.
export const clashSafe = (away, home, c) => {
    if (dist(c[away], c[home]) >= 90) return c;
    if (ALT[away]) return { ...c, [away]: ALT[away] };
    if (ALT[home]) return { ...c, [home]: ALT[home] };
    return c;
};
